import { render, staticRenderFns } from "./reset-reminder-summary.vue?vue&type=template&id=30d0a34c&"
import script from "./reset-reminder-summary.vue?vue&type=script&lang=js&"
export * from "./reset-reminder-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports